import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Authentification } from 'src/app/utils/interfaces/new/authentification.interface';
import { CreateUtilisateur } from 'src/app/utils/interfaces/new/create-utilisateur.interface';
import { CreateAuthentification } from 'src/app/utils/interfaces/new/CreateAuthentification.interface';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { Utilisateur } from 'src/app/utils/interfaces/new/utilisateur.interface';
import { environment } from '../../../environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response'
  };

  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  constructor(
    private http: HttpClient,
    private _snack: SnackbarService
  ) { }

  public async me(): Promise<LocalAuth> {
    try {
      const res = await this.http.get(`${environment.basePath}/hypermed/users/me`, this.httpOptions).toPromise();
      return res.body as LocalAuth;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async getCertificatEtablissement(type: 'DMP' | 'INSI'): Promise<string | undefined> {
    try {
      const cert = await this.http.get<string>(`${environment.basePath}/hypermed/users/me/certificat/${type}`, this.httpOptions).toPromise();
      return cert.body;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async create(user: CreateUtilisateur): Promise<string> {
    try {
      const res = await this.http.post(`${environment.basePath}/hypermed/users`, user, this.httpOptions).toPromise();
      return res.body as string;
    } catch (error) {
      if (error.status != 409) {
        this._snack.openSnackBar(error.error.message);
      }
      throw error;
    }
  }

  public async find(): Promise<Utilisateur[]> {
    try {
      const res = await this.http.get(`${environment.basePath}/hypermed/users`, this.httpOptions).toPromise();
      const users = res.body as Utilisateur[];
      return users;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findUserProfils(id: string): Promise<Profil[]> {
    try {
      const res = await this.http.get(`${environment.basePath}/hypermed/users/${id}/profils`, this.httpOptions).toPromise();
      const profils = res.body as Profil[];
      return profils;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findMyProfils(): Promise<Profil[]> {
    try {
      const res = await this.http.get(`${environment.basePath}/hypermed/users/me/profils`, this.httpOptions).toPromise();
      const profils = res.body as Profil[];
      return profils;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findMyAuths(): Promise<Authentification[]> {
    try {
      const res = await this.http.get(`${environment.basePath}/hypermed/users/me/auths`, this.httpOptions).toPromise();
      const profils = res.body as Authentification[];
      return profils;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
      return [];
    }
  }

  public async addNewAuth(auth: CreateAuthentification): Promise<void> {
    try {
      const res = await this.http.post(`${environment.basePath}/hypermed/users/me/auths`, auth, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async deleteAuth(id): Promise<void> {
    try {
      const res = await this.http.delete(`${environment.basePath}/hypermed/users/me/auths/${id}`, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOne(id: string): Promise<Utilisateur> {
    try {
      const res = await this.http.get(`${environment.basePath}/hypermed/users/${id}`, this.httpOptions).toPromise();
      const user = res.body as Utilisateur;
      return user;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async delete(user: Utilisateur): Promise<void> {
    try {
      user.disabled = true;
      const res = await this.http.put(`${environment.basePath}/hypermed/users/${user.id}`, user, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async update(user: Utilisateur): Promise<void> {
    try {
      const res = await this.http.put(`${environment.basePath}/hypermed/users/${user.id}`, user, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async updateMe(user: Utilisateur): Promise<void> {
    try {
      delete user.admin;
      delete user.disabled;
      delete user.email;
      delete user.pseudo;
      delete user.secretaire;
      const res = await this.http.put(`${environment.basePath}/hypermed/users/me`, user, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
